import {Injectable, inject} from '@angular/core'
import {ConfigAgent, WarehouseProfile} from '@models/configAgent'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {InfoService} from './info.service'

/**
 * Variante embebida de `InfoService`.
 *
 * @description
 * En modo embebido los datos no vienen de PouchDB/`Info` sino del payload recibido por
 * `EmbeddedStoreService`. Sobrescribe los getters de configuración, clasificadores y
 * perfiles de almacén. Devuelve objetos vacíos para actividades, ya que el flujo embebido
 * no las necesita.
 */
@Injectable({
  providedIn: 'root',
})
export class InfoEmbeddedService extends InfoService {
  private readonly embeddedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)
  override getConfigAgent = async (): Promise<ConfigAgent> => {
    return this.embeddedStoreService.configAgent()
  }

  override getClassifiersData = async (): Promise<any> => this.embeddedStoreService.infoClassifiers()

  override getActivitiesData = async (): Promise<any> => ({
    objectives: [],
    activities: [],
    reasons: [],
    types: [],
  })

  override getWarehouseProfiles = async (): Promise<WarehouseProfile[] | null> =>
    this.embeddedStoreService.warehousesProfiles() ?? []
}
